
import React from "react";
import { Check, X } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ComparisonSection = () => {
  const competitors = [
    {
      name: "Dr.Cash",
      rate: "1,9%",
      multipleAcquirers: true,
      multipleClinics: true,
      singleRate: true,
      highlight: true
    },
    {
      name: "Cielo",
      rate: "2,9%",
      multipleAcquirers: false,
      multipleClinics: false,
      singleRate: false
    },
    {
      name: "Stone",
      rate: "2,6%",
      multipleAcquirers: false,
      multipleClinics: false,
      singleRate: false
    },
    {
      name: "GetNet",
      rate: "2,4%",
      multipleAcquirers: false,
      multipleClinics: false,
      singleRate: false
    }
  ];

  return (
    <section className="py-20 bg-drcash-maastricht-blue text-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-1 bg-drcash-caribbean-green/10 rounded-full text-drcash-caribbean-green text-sm mb-6">
            Comparativo
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Dr.Cash vs Concorrentes</h2>
          <p className="max-w-3xl mx-auto text-gray-300">
            Compare as vantagens da Dr.Cash em relação às outras opções de antecipação disponíveis no mercado. A tabela abaixo apresenta um exemplo de taxas para antecipação de recebíveis de um período de 12 meses.
          </p>
        </div>

        <div className="overflow-x-auto">
          <Table className="w-full">
            <TableHeader>
              <TableRow className="border-gray-700/50">
                <TableHead className="text-gray-300">Empresa</TableHead>
                <TableHead className="text-gray-300">Tx. de antecipação mensal</TableHead>
                <TableHead className="text-gray-300">Múltiplas Adquirentes</TableHead>
                <TableHead className="text-gray-300">Múltiplas Clínicas</TableHead>
                <TableHead className="text-gray-300">Taxa Única</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {competitors.map((competitor) => (
                <TableRow 
                  key={competitor.name} 
                  className={`border-gray-700/50 ${competitor.highlight ? 'bg-drcash-caribbean-green/10' : ''}`}
                >
                  <TableCell className={`font-medium ${competitor.highlight ? 'text-drcash-caribbean-green' : 'text-white'}`}>
                    {competitor.name}
                  </TableCell>
                  <TableCell>{competitor.rate}</TableCell>
                  <TableCell>
                    {competitor.multipleAcquirers ? (
                      <Check className="text-drcash-caribbean-green h-5 w-5" />
                    ) : (
                      <X className="text-gray-500 h-5 w-5" />
                    )}
                  </TableCell>
                  <TableCell>
                    {competitor.multipleClinics ? (
                      <Check className="text-drcash-caribbean-green h-5 w-5" />
                    ) : (
                      <X className="text-gray-500 h-5 w-5" />
                    )}
                  </TableCell>
                  <TableCell>
                    {competitor.singleRate ? (
                      <Check className="text-drcash-caribbean-green h-5 w-5" />
                    ) : (
                      <X className="text-gray-500 h-5 w-5" />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        <div className="mt-6 p-4 rounded-lg border border-gray-700/50 bg-white/5">
          <p className="text-gray-300 text-sm">
            É possível encontrar taxas menores nos concorrentes, mas geralmente estão atreladas a uma produção mínima, ou seja, só tem acesso a elas quem fatura alto. A Dr.Cash oferece taxa única independentemente do volume de transações.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
